import React from 'react';
import { useTranslation } from 'react-i18next';
import WhiteSectionContainer from '../../components/containers/WhiteSectionContainer';
import SectionHeader from '../../components/headers/SectionHeader';
import styles from './BuildInfo.module.scss';

const BuildInfo = (): React.ReactElement | null => {
    const { t: txt } = useTranslation();
    const commitSha = process.env.REACT_APP_COMMIT_SHA;
    const buildVersion = process.env.REACT_APP_BUILD_VERSION;
    const buildTimestamp = process.env.REACT_APP_BUILD_TIMESTAMP;

    if (!commitSha && !buildVersion && !buildTimestamp) {
        return null;
    }

    return (
        <div>
            <SectionHeader headerName="BuildInfo.Title" headerType={3} />
            <WhiteSectionContainer>
                <p className={styles.info}>
                    {buildVersion && (
                        <>
                            <span>
                                {txt('BuildInfo.Version')}: {buildVersion}
                            </span>
                            <br />
                        </>
                    )}
                    {commitSha && (
                        <>
                            <span>
                                {txt('BuildInfo.Commit')}: {commitSha}
                            </span>
                            <br />
                        </>
                    )}
                    {buildTimestamp && (
                        <span>
                            {txt('BuildInfo.Built')}: {buildTimestamp}
                        </span>
                    )}
                </p>
            </WhiteSectionContainer>
        </div>
    );
};

export default BuildInfo;
